/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Channel_DdpInputs */

const en_price_channel_ddp = /** @type {(inputs: Price_Channel_DdpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivered duty paid`)
};

/**
* | output |
* | --- |
* | "Delivered duty paid" |
*
* @param {Price_Channel_DdpInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const price_channel_ddp = /** @type {((inputs?: Price_Channel_DdpInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Channel_DdpInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_price_channel_ddp(inputs)
});